export default function tablePagination({ variables, }) {
    return {
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    overflow: "visible",
                    color: variables.text_medium,
                    fontFamily: variables.type_caption_font_family,
                    fontSize: variables.type_caption_font_size,
                },
                toolbar: {
                    minHeight: 0,
                    padding: 0,
                    justifyContent: "flex-end",
                    gap: variables.spacing_02,
                    "@media (min-width:600px)": {
                        minHeight: 0,
                        paddingRight: 0,
                    },
                    "& .MuiTablePagination-actions": {
                        order: 1,
                        marginLeft: 0,
                        flexShrink: 0,
                    },
                    "& .MuiTablePagination-input": {
                        order: 2,
                        marginLeft: variables.spacing_03,
                        marginRight: 0,
                        height: "24px",
                        border: `1px solid ${variables.border_subtle}`,
                        borderRadius: variables.border_radius_small,
                        backgroundColor: variables.surface,
                        color: variables.text_medium,
                    },
                },
                select: {
                    display: "flex",
                    alignItems: "center",
                    minHeight: "24px",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: variables.spacing_02,
                    paddingRight: variables.spacing_06,
                    fontFamily: variables.type_caption_font_family,
                    fontSize: variables.type_caption_font_size,
                },
                selectIcon: {
                    color: variables.text_medium,
                },
            },
        },
    };
}
//# sourceMappingURL=tablePagination.js.map